import * as React from 'react'
import { useAtom } from 'jotai'
import { useMount } from 'react-nb-hooks'

import { ReduxStore } from './store'
import { reduxStoreAtom } from './store/storeAtoms'

type AppContextType = {
  store: ReduxStore
}

const AppContext = React.createContext<AppContextType>(null)

export const AppProvider: React.FC<{ value: AppContextType; children: React.ReactNode }> = ({ value, children }) => {
  const [, setReduxStore] = useAtom(reduxStoreAtom)

  useMount(() => {
    setReduxStore(value.store)
  })

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

function useGlobal(kind: string) {
  const context = React.useContext(AppContext)
  return context[kind]
}

export function useApi() {
  return useGlobal('api')
}
